import { gql } from '@apollo/client'

export const JOIN_FANTASY_LEAGUE = gql`
  mutation JoinFantasyLeague($input: JoinFantasyLeagueInput!) {
    joinFantasyLeague(input: $input) {
      fantasyLeague {
        id
        name
        isPublic
        participantsCount
        creator {
          id
          fullName
        }
      }
      errors
    }
  }
`
